import { useCallback, useEffect } from 'react'

import {
  useFilterStore,
  useZoneInformationStore,
} from '../../../../state-library/src'
import { EPropertyType, ESearchLevel } from '../../../../types-library/src'
import { getPropertiesSummary } from '../../../../apis-library/src'

const ZoneInformationBySearchLoader = () => {
  const {
    constructionType,
    propertyType,
    searchLevel: sLevel,
    rooms: bedrooms,
    // bedroomsQuantityCriteria,
    bathrooms,
    // bathroomsQuantityCriteria,
    parkings,
    // parkingsQuantityCriteria,
    latitude,
    longitude,
    priceFrom,
    priceTo,
    opportunityCriteria,
    publishedDate,
    areaBounds,
    pamRequestId,
    amenities,
    origin,
    associationIds,
    showOnlyCommissionProperties,
    commissionRateLowRange,
    commissionRateHighRange,
    surfaceFrom,
    surfaceTo,
    listingsSource,
    wiggotUserType,
  } = useFilterStore()

  const { setIsLoading, setZone } = useZoneInformationStore()

  const getZoneInfo = useCallback(async () => {
    try {
      setIsLoading(true)

      let searchLevel

      switch (sLevel) {
        case ESearchLevel.BlOCK:
        case ESearchLevel.PROPERTY:
          searchLevel = ESearchLevel.NEIGHBORHOOD
          break
        default:
          searchLevel = sLevel
          break
      }

      const propertyTypeForEndpoint =
        propertyType === EPropertyType.RENT ? 'for-rent' : 'for-sale'
      let queryParam = ''

      if (latitude !== undefined) {
        queryParam += `?latitude=${latitude}`
      }
      if (longitude !== undefined) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&longitude=${longitude}`
            : `${queryParam}?longitude=${longitude}`
      }
      if (searchLevel) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&searchLevel=${searchLevel}`
            : `${queryParam}?searchLevel=${searchLevel}`
      }
      if (propertyTypeForEndpoint) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&propertyType=${propertyTypeForEndpoint}`
            : `${queryParam}?propertyType=${propertyTypeForEndpoint}`
      }

      if (origin) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&origin=${origin}`
            : `${queryParam}?origin=${origin}`
      }

      if (surfaceFrom) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&surfaceFrom=${surfaceFrom}`
            : `${queryParam}?surfaceFrom=${surfaceFrom}`
      }

      if (surfaceTo) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&surfaceTo=${surfaceTo}`
            : `${queryParam}?surfaceTo=${surfaceTo}`
      }

      if (associationIds) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&associationIds=${associationIds}`
            : `${queryParam}?associationIds=${associationIds}`
      }
      if (commissionRateLowRange) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&commissionRateLowRange=${commissionRateLowRange}&commissionRateHighRange=${commissionRateHighRange}`
            : `${queryParam}?commissionRateLowRange=${commissionRateLowRange}&commissionRateHighRange=${commissionRateHighRange}`
      }

      if (showOnlyCommissionProperties) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&showOnlyCommissionProperties=${showOnlyCommissionProperties}`
            : `${queryParam}?showOnlyCommissionProperties=${showOnlyCommissionProperties}`
      }
      if (listingsSource) {
        const param = `listingsSource=${listingsSource}`
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&${param}`
            : `${queryParam}?${param}`
      }
      if (wiggotUserType) {
        const param = `wiggotUserType=${wiggotUserType}`
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&${param}`
            : `${queryParam}?${param}`
      }
      if (constructionType) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&propertyTypes=${constructionType}`
            : `${queryParam}?propertyTypes=${constructionType}`
      }
      if (bedrooms !== undefined) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&bedrooms=${bedrooms}`
            : `${queryParam}?bedrooms=${Number(bedrooms)}`
      }

      //   if (bedroomsQuantityCriteria) {
      //     queryParam =
      //       queryParam.length > 1
      //         ? `${queryParam}&bedroomsQuantityCriteria=${bedroomsQuantityCriteria}`
      //         : `${queryParam}?bedroomsQuantityCriteria=${bedroomsQuantityCriteria}`
      //   }

      if (bathrooms !== undefined) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&bathrooms=${bathrooms}`
            : `${queryParam}?bathrooms=${Number(bathrooms)}`
      }

      //   if (bathroomsQuantityCriteria) {
      //     queryParam =
      //       queryParam.length > 1
      //         ? `${queryParam}&bathroomsQuantityCriteria=${bathroomsQuantityCriteria}`
      //         : `${queryParam}?bathroomsQuantityCriteria=${bathroomsQuantityCriteria}`
      //   }

      if (parkings !== undefined) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&parkings=${parkings}`
            : `${queryParam}?parkings=${Number(parkings)}`
      }

      //   if (parkingsQuantityCriteria) {
      //     queryParam =
      //       queryParam.length > 1
      //         ? `${queryParam}&parkingsQuantityCriteria=${parkingsQuantityCriteria}`
      //         : `${queryParam}?parkingsQuantityCriteria=${parkingsQuantityCriteria}`
      //   }

      queryParam += queryParam ? `&` : '?'
      queryParam += `budgetLowRange=${priceFrom}&budgetHighRange=${priceTo}`

      if (opportunityCriteria) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&opportunityCriteria=${opportunityCriteria}`
            : `${queryParam}?opportunityCriteria=${opportunityCriteria}`
      }

      if (publishedDate) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&proxyPublishedAt=${publishedDate}`
            : `${queryParam}?proxyPublishedAt=${publishedDate}`
      }

      if (amenities.length) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&amenities=${amenities.join(',')}`
            : `${queryParam}?amenities=${amenities.join(',')}`
      }

      if (areaBounds.length > 0) {
        const bounds = areaBounds
          .map((bound) => `[${bound.join(',')}]`)
          .join(',')
        queryParam += queryParam ? `&` : '?'
        queryParam += `boundsFilter=${bounds}`
      }

      if (pamRequestId) {
        queryParam =
          queryParam.length > 1
            ? `${queryParam}&pamRequestId=${pamRequestId}`
            : `${queryParam}?pamRequestId=${pamRequestId}`
      }

      queryParam += queryParam ? `&` : '?'
      queryParam += `isPropertyRepo=true`

      const { data } = await getPropertiesSummary(queryParam)

      if (data) {
        setZone({
          totalCount: data?.totalCount ?? 0,
          avgPrice: data?.avgPrice ?? 0,
          avgM2Price: data?.avgM2Price ?? 0,
          avgSurface: data?.avgSurface ?? 0,
        })

        setIsLoading(false)
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }, [
    bedrooms,
    // bedroomsQuantityCriteria,
    bathrooms,
    // bathroomsQuantityCriteria,
    parkings,
    // parkingsQuantityCriteria,
    constructionType,
    latitude,
    longitude,
    priceFrom,
    priceTo,
    propertyType,
    sLevel,
    // setZoneInfoCount,
    // setZoneInfoSummary,
    opportunityCriteria,
    areaBounds,
    pamRequestId,
    origin,
    associationIds,
    showOnlyCommissionProperties,
    commissionRateLowRange,
    commissionRateHighRange,
    surfaceFrom,
    surfaceTo,
    listingsSource,
    wiggotUserType,
  ])

  //* Observers
  useEffect(() => {
    if (
      !latitude ||
      !longitude
      //   isLoadingHistogram ||
      //   (!pamRequestId && (!priceFrom || !priceTo))
    ) {
      return
    }
    getZoneInfo()
  }, [
    bedrooms,
    // bedroomsQuantityCriteria,
    bathrooms,
    // bathroomsQuantityCriteria,
    parkings,
    // parkingsQuantityCriteria,
    constructionType,
    latitude,
    longitude,
    priceFrom,
    priceTo,
    propertyType,
    sLevel,
    opportunityCriteria,
    areaBounds,
    // isLoadingHistogram,
    pamRequestId,
    origin,
    associationIds,
    showOnlyCommissionProperties,
    commissionRateLowRange,
    commissionRateHighRange,
    surfaceFrom,
    surfaceTo,
    listingsSource,
    wiggotUserType,
  ])
  return <></>
}

export default ZoneInformationBySearchLoader